import { i18n } from '@fs/zion-locale'
import { useFeatureFlag } from '@fs/zion-flags'
import { useCanAddPersonalData } from '@fs/zion-permissions'
import useFamilyTreeLinks from './useFamilyTreeLinks'
import useSearchLinks from './useSearchLinks'
import useMemoriesLinks from './useMemoriesLinks'
import useGetInvolvedLinks from './useGetInvolvedLinks'
import useActivitiesLinks from './useActivitiesLinks'
import useTempleLinks from './useTempleLinks'
import isCoreLanguage from './isCoreLanguage'

const isAuthorizedLinks = (menu) => {
  const linksToHideOnUnauthorized = ['memories', 'family_groups_trees', 'indexing', 'activities']
  return linksToHideOnUnauthorized.includes(menu.id)
}

export default function useLinks({ canSeeTemple, nonReligiousMode, restrictedTemple }) {
  const treeLinks = useFamilyTreeLinks({ canSeeTemple })
  const searchLinks = useSearchLinks({ nonReligiousMode })
  const memoriesLinks = useMemoriesLinks()
  const getInvolvedLinks = useGetInvolvedLinks()
  const activitiesLinks = useActivitiesLinks()
  const templeLinks = useTempleLinks({ restrictedTemple })
  const getInvolvedNavFlagIsOn = useFeatureFlag('home_header_showGetInvolvedNavAddLangs').isOn
  const [isAuthorized] = useCanAddPersonalData()

  let links = [treeLinks, searchLinks, memoriesLinks, getInvolvedLinks, activitiesLinks, templeLinks]

  links = links.filter((menu) => {
    let keep = true

    if (
      menu.id === 'get-involved' &&
      (nonReligiousMode ||
        !(
          isCoreLanguage(i18n.language) ||
          ['nl', 'pl', 'sv'].includes(i18n.language) ||
          (getInvolvedNavFlagIsOn && ['cs', 'da', 'hu', 'no', 'ro', 'uk', 'sm'].includes(i18n.language))
        ))
    ) {
      keep = false
    }
    if (menu.id === 'temple' && !canSeeTemple) {
      keep = false
    }
    if (!isAuthorized && isAuthorizedLinks(menu)) {
      keep = false
    }

    return keep
  })

  if (!isAuthorized)
    links = links.map((link) => {
      return { ...link, sub: link.sub.filter((menu) => !isAuthorizedLinks(menu)) }
    })

  return links
}
